import { isValidEmailAddress, sanitizeEmail } from '~/utils/EmailUtils';

export const MAX_INVITE_EMAILS = 10;

export type ParseInviteEmailsResult = {
  emails: string[];
  error?: string;
};

export const parseInviteEmails = (value?: string): ParseInviteEmailsResult => {
  const emails = (value || '')
    .split(',')
    .map((email) => sanitizeEmail(email))
    .filter(Boolean);

  if (emails.length > MAX_INVITE_EMAILS) {
    return {
      emails: [],
      error: `You can invite up to ${MAX_INVITE_EMAILS} people at a time.`,
    };
  }

  const invalidEmails = emails.filter((email) => !isValidEmailAddress(email));

  if (invalidEmails.length) {
    return {
      emails: [],
      error: 'Enter valid email addresses separated by commas.',
    };
  }

  const uniqueEmails: string[] = [];

  emails.forEach((email) => {
    if (!uniqueEmails.includes(email)) {
      uniqueEmails.push(email);
    }
  });

  return { emails: uniqueEmails };
};
